import { connect } from "react-redux";
import { default as ClearSpecificationsButton } from "./ClearSpecificationsButton";

// actions
import { clearWorkingAreaSpecifications } from "store/actions/specifications";

const mapStateToProps = ({ specifications: slice }) => ({
    show: (slice.page.workingArea.specifications.length > 0),
});

const mapDispatchToProps = { clear: clearWorkingAreaSpecifications };

export default connect(mapStateToProps, mapDispatchToProps)(ClearSpecificationsButton);
